import { FormLayout } from 'components/common'
import { SortableList } from 'components/common/sortableList'
import { UseFormSetValue, FieldValues, FieldErrors } from 'react-hook-form'

type Props = {
  setValue: UseFormSetValue<FieldValues>
  specialCategories?: string[]
  errors?: FieldErrors<FieldValues>
  loading?: boolean
}

/**
 * Special categories double as their own configured display order — the
 * array's element order is what the backend applies when grouping the
 * Deliveroo catalogue payload (see buildSpecialCategoryGroups.ts on the
 * backend). Add, remove, and drag-to-reorder all live in one sortable list
 * so there is a single source of truth instead of a separate "order" config.
 */
const SpecialCategoriesSection = ({
  setValue,
  specialCategories,
  errors,
  loading,
}: Props) => {
  return (
    <>
      <h3 className="title">Catalogue Special Category Config</h3>
      <FormLayout>
        <div className="md:w-1/2">
          <SortableList
            name="specialCategories"
            label="Special Categories"
            placeholder="Add a special category"
            emptyText="No special categories yet"
            setValue={setValue}
            defaultValues={specialCategories}
            errors={errors}
            loading={loading}
          />
        </div>
      </FormLayout>
    </>
  )
}

export default SpecialCategoriesSection
